import { createContext } from 'react';

type LetterContextType = {
  letterId: string;
};

export const LetterContext = createContext<LetterContextType | undefined>(undefined);
